<template>
  <div class="sidebar">
    <SidebarHeader />
    <SidebarForm />
    <nav class="sidebar-nav">
      <ul class="nav">
        <template v-for="(item, index) in navItems">
          <SidebarNavTitle
            v-if="item.title"
            :name="item.name"
            :classes="item.class"
            :wrapper="item.wrapper"
            :key="index"
          />
          <SidebarNavDivider
            v-else-if="item.divider"
            :classes="item.class"
            :key="index"
          />
          <SidebarNavLabel
            v-else-if="item.label"
            :name="item.name"
            :url="item.url"
            :icon="item.icon"
            :label="item.label"
            :classes="item.class"
            :key="index"
          />
          <template v-else>
            <!-- First level dropdown -->
            <SidebarNavDropdown
              v-if="item.children"
              :name="item.name"
              :url="item.url"
              :icon="item.icon"
              :key="index"
            >
              <template v-for="(childL1, index) in item.children">
                <template v-if="childL1.children">
                  <!-- Second level dropdown -->
                  <SidebarNavDropdown
                    :name="childL1.name"
                    :url="childL1.url"
                    :icon="childL1.icon"
                    :key="index"
                  >
                    <li
                      class="nav-item"
                      v-for="(childL2, index) in childL1.children"
                      :key="index"
                    >
                      <SidebarNavLink
                        :id="item.id"
                        :name="childL2.name"
                        :url="childL2.url"
                        :icon="childL2.icon"
                        :badge="childL2.badge"
                        :variant="item.variant"
                        :target="item.target"
                      />
                    </li>
                  </SidebarNavDropdown>
                </template>
                <SidebarNavItem v-else :classes="item.class" :key="index">
                  <SidebarNavLink
                    :id="item.id"
                    :name="childL1.name"
                    :url="childL1.url"
                    :icon="childL1.icon"
                    :badge="childL1.badge"
                    :variant="item.variant"
                    :target="item.target"
                  />
                </SidebarNavItem>
              </template>
            </SidebarNavDropdown>
            <SidebarNavItem v-else :classes="item.class" :key="index">
              <SidebarNavLink
                :id="item.id"
                :name="item.name"
                :url="item.url"
                :icon="item.icon"
                :badge="item.badge"
                :variant="item.variant"
                :target="item.target"
              />
            </SidebarNavItem>
          </template>
        </template>
      </ul>
      <slot></slot>
    </nav>
    <SidebarFooter />
    <SidebarMinimizer />
  </div>
</template>
<script>
import SidebarFooter from "./SidebarFooter";
import SidebarForm from "./SidebarForm";
import SidebarHeader from "./SidebarHeader";
import SidebarMinimizer from "./SidebarMinimizer";
import SidebarNavDivider from "./SidebarNavDivider";
import SidebarNavDropdown from "./SidebarNavDropdown";
import SidebarNavLink from "./SidebarNavLink";
import SidebarNavTitle from "./SidebarNavTitle";
import SidebarNavItem from "./SidebarNavItem";
import SidebarNavLabel from "./SidebarNavLabel";

import nav from "@/data/nav";
import { mapGetters } from "vuex";

export default {
  name: "sidebar",

  components: {
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNavDivider,
    SidebarNavDropdown,
    SidebarNavLink,
    SidebarNavTitle,
    SidebarNavItem,
    SidebarNavLabel
  },

  computed: {
    ...mapGetters(["isAdmin"]),
    ...mapGetters("user", ["hasPermission"]),
    ...mapGetters("chat", ["unread"]),

    navItems() {
      return nav.items
        .filter(item => {
          if (!item.permission) return true;
          if (this.isAdmin) return false;
          const permissions = [].concat(item.permission);
          return permissions.some(this.hasPermission);
        })
        .map(item => {
          if (item.name === "Chat" && this.unread) {
            item = { ...item };
            item.badge = {
              variant: "primary",
              text: this.unread
            };
          }
          return item;
        });
    }
  },

  methods: {
    handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle("open");
    }
  }
};
</script>

<style lang="css">
.nav-link {
  cursor: pointer;
}
</style>
